import { combineEpics } from 'redux-observable';
import { updateUserGroupsEpic } from './update-user-groups-epic';

export const combinedUsersGroupsEpics = combineEpics(
    updateUserGroupsEpic
);
